import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {FragmentComponent} from '@nh/angular-tses';

@Component({
  selector: 'das-html-fragment',
  templateUrl: './html-fragment.component.html',
  styleUrls: ['./html-fragment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HTMLFragmentComponent extends FragmentComponent {
  constructor(protected _cd: ChangeDetectorRef, elementRef: ElementRef, private sanitizer: DomSanitizer) {
    super(_cd, elementRef);
  }

  public bypass(text: string) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
